export default {
  'payment': {
    'choosePlan': 'Hãy chọn\nGói thành viên\n Phù hợp với bạn',
    'monthly': '1 tháng',
    'yearly': '1 năm',
    'discount': 'giảm {{ discount }}%',
    'register': 'Đăng ký',
    'registered': 'Đã đăng ký',
    'plan': {
      'free': {
        'title': 'Miễn phí',
        'description': 'Tham gia vào cộng đồng rộng lớn\n\nTruy cập vào các đề thi MIỄN PHÍ để phát triển kiến thức và kĩ năng'
      },
      'smart': {
        'title': 'Làm đề',
        'description': 'Phù hợp với học sinh, sinh viên, người đi học, ...'
      },
      'talented': {
        'title': 'Tạo đề',
        'description': 'Phù hợp với giáo viên, nhóm học, tổ chức đoàn, công ty, ...'
      },
      'superb': {
        'title': 'Cao cấp',
        'include': 'Bao gồm toàn bộ các tính năng của gói THÔNG THÁI và TÀI NĂNG:',
        'description': 'Phù hợp với nhu cầu tạo đề và làm đề'
      }
    }
  }
}
